<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int, validate_not_empty} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import {decode, encode} from "../../../helpers";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))

            fetchData = await fetch();

            let title = item.title.split(', ');

            width.set(+title[1].split('x')[0]);
            height.set(+title[1].split('x')[1]);

            ind2 = json.ind2
            ind4 = json.ind4
            ind6 = json.ind6
            ind8 = json.ind8
            mestekUpl = json.mestekUpl
            ind10 = json.ind10
            tip = json.tip
            setTimeout(() => kolvoStvorok = json.kolvoStvorok, 200)
            setTimeout(() => tipotkr = json.tipotkr, 250)
            sborka = json.sborka
            nastprof = json.nastprof
            pokraska = json.pokraska
            tipAnod = json.tipAnod
            stvwid = json.stvwid
            vesstvorki = json.vesstvorki
            cvetStopora = json.cvetStopora || 'Серый'
            cvetZaschelki = json.cvetZaschelki || 'Серый'

            count.set(+item.quantity)
            comment.set(item.comment)
            change()
        }
    };

    const openingtype = {
        'влево': 'Влево',
        'вправо': 'Вправо',
        'двойное': 'Двойное',
        'от-центра': 'От центра',
    };
    const openingLeftRightTwin = [
        '2',
        '3',
        '4',
    ];
    const openingCentr = [
        '4',
        '6',
        '8',
    ];
    const color_type = [
        'Глянцевый',
         'Матовый',
         'Муар',
    ];
    const glassDiler = {
        'Без стекла': 'Без стекла',
    };
    const glass = {
        'Без стекла': 'Без стекла',
        'Прозрачное (M1) 10мм зак.': 'Прозрачное (M1) 10мм зак.',
        'Бронза (AGC) 10мм зак.': 'Бронза (AGC) 10мм зак.',
        'Грей (AGC) 10мм зак.': 'Грей (AGC) 10мм зак.',
        'Матовое 10мм зак.': 'Матовое 10мм зак.',
        'Сатин (матовое) 10мм зак.': 'Сатин (матовое) 10мм зак.',
        'Мультифункциональное (Neutral 67) 10мм зак.': 'Мультифункциональное (Neutral 67) 10мм зак.',
        'Просветленное (AGC) 10мм зак.': 'Просветленное (AGC) 10мм зак.',
    };
    const compactor = {
        'Чёрный': 'Чёрный',
        'Серый': 'Серый',
    };
    const handleDiler = {
        'Ручка своя': 'Ручка своя',
        'Ручка купе FDR-10, нержавейка-черный': 'Ручка купе FDR-10, нержавейка-черный',
        'Ручка купе FDR-10, нержавейка-полированный': 'Ручка купе FDR-10, нержавейка-полированный',

    };
    const handle = {
        'Ручка своя': 'Ручка своя',
        'Ручка-профиль': 'Ручка-профиль',
        'Ручка купе, нержавейка-черный':'Ручка купе, нержавейка-черный',
        'Ручка купе, нержавейка-полированный': 'Ручка купе, нержавейка-полированный',
        'Ручка купе FDR-10, нержавейка-черный': 'Ручка купе FDR-10, нержавейка-черный',
        'Ручка купе FDR-10, нержавейка-полированный': 'Ручка купе FDR-10, нержавейка-полированный',
        'Ручка FKR-206 для стеклянной двери 32x400х600х1 мм, нержавейка-черный': 'Ручка FKR-206 для стеклянной двери 32x400х600х1 мм, нержавейка-черный',
        'Ручка FKR-206 для стеклянной двери 32x400х600х1 мм, нержавейка-матовый': 'Ручка FKR-206 для стеклянной двери 32x400х600х1 мм, нержавейка-матовый',

    };
    const handleImages = {
        'Ручка-профиль': 'Ручка-профиль.jpg',
        'Ручка купе, нержавейка-черный':'kupe2.jpg',
        'Ручка купе, нержавейка-полированный': 'kupe1.jpg',
        'Ручка купе FDR-10, нержавейка-черный': 'Ручка купе FDR-10, нержавейка-черный.webp',
        'Ручка купе FDR-10, нержавейка-полированный': 'Ручка купе FDR-10, нержавейка-полированный.webp',
        'Ручка FKR-206 для стеклянной двери 32x400х600х1 мм, нержавейка-черный': 'Ручка FKR-206 для стеклянной двери 32x400х600х1 мм, нержавейка-черный.webp',
        'Ручка FKR-206 для стеклянной двери 32x400х600х1 мм, нержавейка-матовый': 'Ручка FKR-206 для стеклянной двери 32x400х600х1 мм, нержавейка-матовый.webp',

    };
    const zamok = {
        'Без замка и без защелки': 'Без замка и без защелки',
        'Замок-защелка нижний': 'Замок-защелка нижний',
        'Замок-защелка боковой': 'Замок-защелка боковой',
    };
    const zamokOtCentr = {
        'Без замка и без защелки': 'Без замка и без защелки',
        'Замок на стекло (от центра)': 'Замок на стекло (от центра)',
        'Замок-защелка нижний': 'Замок-защелка нижний',
        'Замок-защелка боковой': 'Замок-защелка боковой',
    };
    const mezstekolka = {
        'ПВХ уплотнитель с фетром': 'ПВХ уплотнитель с фетром',
        'Алюминиевый уплотнитель с фетром':'Алюминиевый уплотнитель с фетром',
        'Межстекольный зацеп':'Межстекольный зацеп',
    };

    const tips = {
        '3': '3 рельсовая',
        '4': '4 рельсовая',
        '5': '5 рельсовая',
        '6': '6 рельсовая',
        '7': '7 рельсовая',
        '8': '8 рельсовая',
        '9': '9 рельсовая',
        '10': '10 рельсовая',
    };
    const rels3 = {
        '2': '2 створки',
        '3': '3 створки',
        '4': '4 створки',
        '5': '5 створок',
        '6': '6 створок',
    };
    const rels4 = {
        '4': '4 створки',
        '5': '5 створок',
        '6': '6 створок',
        '7': '7 створок',
        '8': '8 створок',
    };
    const rels5 = {
        '5': '5 створок',
        '6': '6 створок',
        '7': '7 створок',
        '8': '8 створок',
        '9': '9 створок',
        '10': '10 створок',
        '12': '12 створок',
    };
    const rels6 = {
        '6': '6 створок',
    };
    const rels7 = {
        '7': '7 створок',
    };
    const rels8 = {
        '8': '8 створок',
    };
    const rels9 = {
        '9': '9 створок',
    };
    const rels10 = {
        '10': '10 створок',
    };
    const opening3rels2stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',

    };
    const opening3rels3stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',
    };
    const opening3rels4stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'От-центра': 'От центра',
    };
    const opening3rels5stvorki = {
        'От-центра-1': 'От центра-1',
        'От-центра-2': 'От центра-2',
    };
    const opening3rels6stvorki = {
        'От-центра': 'От центра',
    };
    const opening4rels4stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',

    };
    const opening4rels5stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
    };
    const opening4rels6stvorki = {
        'От-центра-1': 'От центра-1',
        'От-центра-2': 'От центра-2',
    };
    const opening4rels7stvorki = {
        'От-центра-1': 'От центра-1',
        'От-центра-2': 'От центра-2',
    };
    const opening4rels8stvorki = {
        'От-центра': 'От центра',
    };
    const opening5rels5stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',

    };
    const opening5rels6stvorki = {
        'Влево-1': 'Влево-1',
        'Вправо-1': 'Вправо-1',
        'Влево-2': 'Влево-2',
        'Вправо-2': 'Вправо-2',
   };
    const opening5rels7stvorki = {
        'От-центра-1': 'От центра-1',
        'От-центра-2': 'От центра-2',
    };
    const opening5rels8stvorki = {
        'От-центра-1': 'От центра-1',
        'От-центра-2': 'От центра-2',
    };
    const opening5rels9stvorki = {
        'От-центра-1': 'От центра-1',
        'От-центра-2': 'От центра-2',
    };
    const opening5rels10stvorki = {
        'От-центра': 'От центра',
    };
    const opening6rels6stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',

    };
    const opening7rels7stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',

    };
    const opening8rels8stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',

    };
    const opening9rels9stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',

    };
    const opening10rels10stvorki = {
        'Влево': 'Влево',
        'Вправо': 'Вправо',
        'Двойное': 'Двойное',

    };

    function matchesFurnColor(item, color) {
        const hay = `${item.name} ${item.ind2 || ''}`.toLowerCase().replace(/ё/g, 'е');
        const c = (color || '').toLowerCase().replace(/ё/g, 'е');
        const hasGray = hay.includes('серый');
        const hasBlack = hay.includes('черный');
        if (!hasGray && !hasBlack) return true;
        return hay.includes(c);
    }

    // Функция для получения доступных вариантов створок по типу
    function getAvailableStvorokOptions(tip) {
        const stvorokMap = {
            '3': rels3,
            '4': rels4,
            '5': rels5,
            '6': rels6,
            '7': rels7,
            '8': rels8,
            '9': rels9,
            '10': rels10,
        };
        return stvorokMap[tip] || {};
    }

    // Функция для получения доступных вариантов открывания
    function getAvailableOpeningOptions(tip, stvorok) {
        if (!tip || !stvorok) return {};

        const openingMap = {
            '3': {
                '2': opening3rels2stvorki,
                '3': opening3rels3stvorki,
                '4': opening3rels4stvorki,
                '5': opening3rels5stvorki,
                '6': opening3rels6stvorki,
            },
            '4': {
                '4': opening4rels4stvorki,
                '5': opening4rels5stvorki,
                '6': opening4rels6stvorki,
                '7': opening4rels7stvorki,
                '8': opening4rels8stvorki,
            },
            '5': {
                '5': opening5rels5stvorki,
                '6': opening5rels6stvorki,
                '7': opening5rels7stvorki,
                '8': opening5rels8stvorki,
                '9': opening5rels9stvorki,
                '10': opening5rels10stvorki,
            },
            '6': {
                '6': opening6rels6stvorki,
            },
            '7': {
                '7': opening7rels7stvorki,
            },
            '8': {
                '8': opening8rels8stvorki,
            },
            '9': {
                '9': opening9rels9stvorki,
            },
            '10': {
                '10': opening10rels10stvorki,
            }
        };

        return openingMap[tip]?.[stvorok] || {};
    }

    // Реактивные зависимости
    $: availableStvorokOptions = getAvailableStvorokOptions(tip);

    $: availableOpeningOptions = getAvailableOpeningOptions(tip, kolvoStvorok);

    // Сброс значений и установка первых доступных при изменении типа
    $: if (tip) {
        const stvorokOptions = getAvailableStvorokOptions(tip);
        kolvoStvorok = stvorokOptions ? Object.keys(stvorokOptions)[0] ?? '' : '';
        // ind3 будет сброшен здесь. Его установка произойдет после изменения kolvoStvorok,
        // благодаря другому реактивному блоку.
        //tipotkr = '';
    }

    // Сброс значения открывания и установка первого доступного при изменении створок
    $: if (kolvoStvorok) {
        const openingOptions = getAvailableOpeningOptions(tip, kolvoStvorok);
        tipotkr = openingOptions ? Object.keys(openingOptions)[0] ?? '' : '';
    }

    const colors = [
        ["RAL1000", "/resources/img/ral/1000.jpg"],
        ["RAL1001", "/resources/img/ral/1001.jpg"],
        ["RAL1002", "/resources/img/ral/1002.jpg"],
        ["RAL1003", "/resources/img/ral/1003.jpg"],
        ["RAL1004", "/resources/img/ral/1004.jpg"],
        ["RAL1005", "/resources/img/ral/1005.jpg"],
        ["RAL1006", "/resources/img/ral/1006.jpg"],
        ["RAL1007", "/resources/img/ral/1007.jpg"],
        ["RAL1011", "/resources/img/ral/1011.jpg"],
        ["RAL1012", "/resources/img/ral/1012.jpg"],
        ["RAL1013", "/resources/img/ral/1013.jpg"],
        ["RAL1014", "/resources/img/ral/1014.jpg"],
        ["RAL1015", "/resources/img/ral/1015.jpg"],
        ["RAL1016", "/resources/img/ral/1016.jpg"],
        ["RAL1018", "/resources/img/ral/1018.jpg"],
        ["RAL1019", "/resources/img/ral/1019.jpg"],
        ["RAL1020", "/resources/img/ral/1020.jpg"],
        ["RAL1021", "/resources/img/ral/1021.jpg"],
        ["RAL1023", "/resources/img/ral/1023.jpg"],
        ["RAL1024", "/resources/img/ral/1024.jpg"],
        ["RAL1026", "/resources/img/ral/1026.jpg"],
        ["RAL1027", "/resources/img/ral/1027.jpg"],
        ["RAL1028", "/resources/img/ral/1028.jpg"],
        ["RAL1032", "/resources/img/ral/1032.jpg"],
        ["RAL1033", "/resources/img/ral/1033.jpg"],
        ["RAL1034", "/resources/img/ral/1034.jpg"],
        ["RAL1035", "/resources/img/ral/1035.jpg"],
        ["RAL1036", "/resources/img/ral/1036.jpg"],
        ["RAL1037", "/resources/img/ral/1037.jpg"],
        ["RAL2000", "/resources/img/ral/2000.jpg"],
        ["RAL2001", "/resources/img/ral/2001.jpg"],
        ["RAL2002", "/resources/img/ral/2002.jpg"],
        ["RAL2003", "/resources/img/ral/2003.jpg"],
        ["RAL2004", "/resources/img/ral/2004.jpg"],
        ["RAL2005", "/resources/img/ral/2005.jpg"],
        ["RAL2007", "/resources/img/ral/2007.jpg"],
        ["RAL2008", "/resources/img/ral/2008.jpg"],
        ["RAL2009", "/resources/img/ral/2009.jpg"],
        ["RAL2010", "/resources/img/ral/2010.jpg"],
        ["RAL2011", "/resources/img/ral/2011.jpg"],
        ["RAL2012", "/resources/img/ral/2012.jpg"],
        ["RAL2013", "/resources/img/ral/2013.jpg"],
        ["RAL3000", "/resources/img/ral/3000.jpg"],
        ["RAL3001", "/resources/img/ral/3001.jpg"],
        ["RAL3002", "/resources/img/ral/3002.jpg"],
        ["RAL3003", "/resources/img/ral/3003.jpg"],
        ["RAL3004", "/resources/img/ral/3004.jpg"],
        ["RAL3005", "/resources/img/ral/3005.jpg"],
        ["RAL3007", "/resources/img/ral/3007.jpg"],
        ["RAL3009", "/resources/img/ral/3009.jpg"],
        ["RAL3011", "/resources/img/ral/3011.jpg"],
        ["RAL3012", "/resources/img/ral/3012.jpg"],
        ["RAL3013", "/resources/img/ral/3013.jpg"],
        ["RAL3014", "/resources/img/ral/3014.jpg"],
        ["RAL3015", "/resources/img/ral/3015.jpg"],
        ["RAL3016", "/resources/img/ral/3016.jpg"],
        ["RAL3017", "/resources/img/ral/3017.jpg"],
        ["RAL3018", "/resources/img/ral/3018.jpg"],
        ["RAL3020", "/resources/img/ral/3020.jpg"],
        ["RAL3022", "/resources/img/ral/3022.jpg"],
        ["RAL3024", "/resources/img/ral/3024.jpg"],
        ["RAL3026", "/resources/img/ral/3026.jpg"],
        ["RAL3027", "/resources/img/ral/3027.jpg"],
        ["RAL3028", "/resources/img/ral/3028.jpg"],
        ["RAL3031", "/resources/img/ral/3031.jpg"],
        ["RAL3032", "/resources/img/ral/3032.jpg"],
        ["RAL3033", "/resources/img/ral/3033.jpg"],
        ["RAL4001", "/resources/img/ral/4001.jpg"],
        ["RAL4002", "/resources/img/ral/4002.jpg"],
        ["RAL4003", "/resources/img/ral/4003.jpg"],
        ["RAL4004", "/resources/img/ral/4004.jpg"],
        ["RAL4005", "/resources/img/ral/4005.jpg"],
        ["RAL4006", "/resources/img/ral/4006.jpg"],
        ["RAL4007", "/resources/img/ral/4007.jpg"],
        ["RAL4008", "/resources/img/ral/4008.jpg"],
        ["RAL4009", "/resources/img/ral/4009.jpg"],
        ["RAL4010", "/resources/img/ral/4010.jpg"],
        ["RAL4011", "/resources/img/ral/4011.jpg"],
        ["RAL4012", "/resources/img/ral/4012.jpg"],
        ["RAL5000", "/resources/img/ral/5000.jpg"],
        ["RAL5001", "/resources/img/ral/5001.jpg"],
        ["RAL5002", "/resources/img/ral/5002.jpg"],
        ["RAL5003", "/resources/img/ral/5003.jpg"],
        ["RAL5004", "/resources/img/ral/5004.jpg"],
        ["RAL5005", "/resources/img/ral/5005.jpg"],
        ["RAL5007", "/resources/img/ral/5007.jpg"],
        ["RAL5008", "/resources/img/ral/5008.jpg"],
        ["RAL5009", "/resources/img/ral/5009.jpg"],
        ["RAL5010", "/resources/img/ral/5010.jpg"],
        ["RAL5011", "/resources/img/ral/5011.jpg"],
        ["RAL5012", "/resources/img/ral/5012.jpg"],
        ["RAL5013", "/resources/img/ral/5013.jpg"],
        ["RAL5014", "/resources/img/ral/5014.jpg"],
        ["RAL5015", "/resources/img/ral/5015.jpg"],
        ["RAL5017", "/resources/img/ral/5017.jpg"],
        ["RAL5018", "/resources/img/ral/5018.jpg"],
        ["RAL5019", "/resources/img/ral/5019.jpg"],
        ["RAL5020", "/resources/img/ral/5020.jpg"],
        ["RAL5021", "/resources/img/ral/5021.jpg"],
        ["RAL5022", "/resources/img/ral/5022.jpg"],
        ["RAL5023", "/resources/img/ral/5023.jpg"],
        ["RAL5024", "/resources/img/ral/5024.jpg"],
        ["RAL5025", "/resources/img/ral/5025.jpg"],
        ["RAL5026", "/resources/img/ral/5026.jpg"],
        ["RAL6000", "/resources/img/ral/6000.jpg"],
        ["RAL6001", "/resources/img/ral/6001.jpg"],
        ["RAL6002", "/resources/img/ral/6002.jpg"],
        ["RAL6003", "/resources/img/ral/6003.jpg"],
        ["RAL6004", "/resources/img/ral/6004.jpg"],
        ["RAL6005", "/resources/img/ral/6005.jpg"],
        ["RAL6006", "/resources/img/ral/6006.jpg"],
        ["RAL6007", "/resources/img/ral/6007.jpg"],
        ["RAL6008", "/resources/img/ral/6008.jpg"],
        ["RAL6009", "/resources/img/ral/6009.jpg"],
        ["RAL6010", "/resources/img/ral/6010.jpg"],
        ["RAL6011", "/resources/img/ral/6011.jpg"],
        ["RAL6012", "/resources/img/ral/6012.jpg"],
        ["RAL6013", "/resources/img/ral/6013.jpg"],
        ["RAL6014", "/resources/img/ral/6014.jpg"],
        ["RAL6015", "/resources/img/ral/6015.jpg"],
        ["RAL6016", "/resources/img/ral/6016.jpg"],
        ["RAL6017", "/resources/img/ral/6017.jpg"],
        ["RAL6018", "/resources/img/ral/6018.jpg"],
        ["RAL6019", "/resources/img/ral/6019.jpg"],
        ["RAL6020", "/resources/img/ral/6020.jpg"],
        ["RAL6021", "/resources/img/ral/6021.jpg"],
        ["RAL6022", "/resources/img/ral/6022.jpg"],
        ["RAL6024", "/resources/img/ral/6024.jpg"],
        ["RAL6025", "/resources/img/ral/6025.jpg"],
        ["RAL6026", "/resources/img/ral/6026.jpg"],
        ["RAL6027", "/resources/img/ral/6027.jpg"],
        ["RAL6028", "/resources/img/ral/6028.jpg"],
        ["RAL6029", "/resources/img/ral/6029.jpg"],
        ["RAL6032", "/resources/img/ral/6032.jpg"],
        ["RAL6033", "/resources/img/ral/6033.jpg"],
        ["RAL6034", "/resources/img/ral/6034.jpg"],
        ["RAL6035", "/resources/img/ral/6035.jpg"],
        ["RAL6036", "/resources/img/ral/6036.jpg"],
        ["RAL6037", "/resources/img/ral/6037.jpg"],
        ["RAL6038", "/resources/img/ral/6038.jpg"],
        ["RAL7000", "/resources/img/ral/7000.jpg"],
        ["RAL7001", "/resources/img/ral/7001.jpg"],
        ["RAL7002", "/resources/img/ral/7002.jpg"],
        ["RAL7003", "/resources/img/ral/7003.jpg"],
        ["RAL7004", "/resources/img/ral/7004.jpg"],
        ["RAL7005", "/resources/img/ral/7005.jpg"],
        ["RAL7006", "/resources/img/ral/7006.jpg"],
        ["RAL7008", "/resources/img/ral/7008.jpg"],
        ["RAL7009", "/resources/img/ral/7009.jpg"],
        ["RAL7010", "/resources/img/ral/7010.jpg"],
        ["RAL7011", "/resources/img/ral/7011.jpg"],
        ["RAL7012", "/resources/img/ral/7012.jpg"],
        ["RAL7013", "/resources/img/ral/7013.jpg"],
        ["RAL7015", "/resources/img/ral/7015.jpg"],
        ["RAL7016", "/resources/img/ral/7016.jpg"],
        ["RAL7021", "/resources/img/ral/7021.jpg"],
        ["RAL7022", "/resources/img/ral/7022.jpg"],
        ["RAL7023", "/resources/img/ral/7023.jpg"],
        ["RAL7024", "/resources/img/ral/7024.jpg"],
        ["RAL7026", "/resources/img/ral/7026.jpg"],
        ["RAL7030", "/resources/img/ral/7030.jpg"],
        ["RAL7031", "/resources/img/ral/7031.jpg"],
        ["RAL7032", "/resources/img/ral/7032.jpg"],
        ["RAL7033", "/resources/img/ral/7033.jpg"],
        ["RAL7034", "/resources/img/ral/7034.jpg"],
        ["RAL7035", "/resources/img/ral/7035.jpg"],
        ["RAL7036", "/resources/img/ral/7036.jpg"],
        ["RAL7037", "/resources/img/ral/7037.jpg"],
        ["RAL7038", "/resources/img/ral/7038.jpg"],
        ["RAL7039", "/resources/img/ral/7039.jpg"],
        ["RAL7040", "/resources/img/ral/7040.jpg"],
        ["RAL7042", "/resources/img/ral/7042.jpg"],
        ["RAL7043", "/resources/img/ral/7043.jpg"],
        ["RAL7044", "/resources/img/ral/7044.jpg"],
        ["RAL7045", "/resources/img/ral/7045.jpg"],
        ["RAL7046", "/resources/img/ral/7046.jpg"],
        ["RAL7047", "/resources/img/ral/7047.jpg"],
        ["RAL7048", "/resources/img/ral/7048.jpg"],
        ["RAL8000", "/resources/img/ral/8000.jpg"],
        ["RAL8001", "/resources/img/ral/8001.jpg"],
        ["RAL8002", "/resources/img/ral/8002.jpg"],
        ["RAL8003", "/resources/img/ral/8003.jpg"],
        ["RAL8004", "/resources/img/ral/8004.jpg"],
        ["RAL8007", "/resources/img/ral/8007.jpg"],
        ["RAL8008", "/resources/img/ral/8008.jpg"],
        ["RAL8011", "/resources/img/ral/8011.jpg"],
        ["RAL8012", "/resources/img/ral/8012.jpg"],
        ["RAL8014", "/resources/img/ral/8014.jpg"],
        ["RAL8015", "/resources/img/ral/8015.jpg"],
        ["RAL8016", "/resources/img/ral/8016.jpg"],
        ["RAL8017", "/resources/img/ral/8017.jpg"],
        ["RAL8019", "/resources/img/ral/8019.jpg"],
        ["RAL8022", "/resources/img/ral/8022.jpg"],
        ["RAL8023", "/resources/img/ral/8023.jpg"],
        ["RAL8024", "/resources/img/ral/8024.jpg"],
        ["RAL8025", "/resources/img/ral/8025.jpg"],
        ["RAL8028", "/resources/img/ral/8028.jpg"],
        ["RAL8029", "/resources/img/ral/8029.jpg"],
        ["RAL9001", "/resources/img/ral/9001.jpg"],
        ["RAL9002", "/resources/img/ral/9002.jpg"],
        ["RAL9003", "/resources/img/ral/9003.jpg"],
        ["RAL9004", "/resources/img/ral/9004.jpg"],
        ["RAL9005", "/resources/img/ral/9005.jpg"],
        ["RAL9006", "/resources/img/ral/9006.jpg"],
        ["RAL9007", "/resources/img/ral/9007.jpg"],
        ["RAL9010", "/resources/img/ral/9010.jpg"],
        ["RAL9011", "/resources/img/ral/9011.jpg"],
        ["RAL9016", "/resources/img/ral/9016.jpg"],
        ["RAL9017", "/resources/img/ral/9017.jpg"],
        ["RAL9018", "/resources/img/ral/9018.jpg"],
        ["RAL9022", "/resources/img/ral/9022.jpg"],
        ["RAL9023", "/resources/img/ral/9023.jpg"],
    ];

    const fetch = async (color = '') => {
        let result = await network.fetch_data('СлайдЛюкс', '', '');
        let options = await network.fetch_ind('СлайдЛюкс');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', 4200),
        height = parameter('height', 2700),
        ind2 = '', // цвет RAL
        tipotkr = 'влево', // открытие
        ind4 = 'Прозрачное (M1) 10мм зак.', // стекло
        ind6 = 'Ручка-профиль', // ручки
        ind8 = 'Без замка и без защелки', //

        mestekUpl = 'ПВХ уплотнитель с фетром', // порог
        ind10  = 'Глянцевый', // тип цвета
        kolvoStvorok= '5', // длинна  Труба алюминиевая
        tip = '5',
        sborka = "Да",
        nastprof = "Да",
        pokraska = "RAL",
        tipAnod= "Серебро",
        stvwid= '',
        vesstvorki= 0,
        cvetStopora = 'Серый',
        cvetZaschelki = 'Серый',
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)

    ;

    let fetchData = fetch();

    let ruchka;
    let ruchka2;
    let title;
    let searchRal = '';
    let showRalList = false;

    const changeSborka = _.debounce(() => {
        if ( sborka !== 'Да') {
            ind4 = 'Без стекла';
            pokraska="Без покраски";
        }
        change();
    }, 500);

    // Фильтруем цвета
    $: filteredColors = searchRal
        ? colors.filter(([code]) => code.toLowerCase().includes(searchRal.toLowerCase()))
        : colors;


    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height,
            pokraskaPrice = 0,
            pokraskaOptPrice = 0;


        const stoporTitle = ind6 !== 'Ручка своя' ? ', стопор ' + cvetStopora.toLowerCase() : '';
        const zaschelkaTitle = ind8 === 'Замок-защелка нижний' ? ' ' + cvetZaschelki.toLowerCase() : '';

        if (ind4=='Без стекла'){
            title =  [
                'СлайдЛюкс, ', w + 'x' + h, ', открытие ',
                tipotkr, ', ', tip, ' рельсовая, ', kolvoStvorok, ' створки(ок) ', ((pokraska =='RAL'|| pokraska =='АкзоНобель')? ', цвет '+ind2 + ' '+ ind10 : pokraska =='Анодирование'? ', Анодирование '+ tipAnod :  'Без покраски' ), ', Без стекла ', ', ', ind6,
                stoporTitle, ', ', ind8, zaschelkaTitle, ', ', mestekUpl, ', ', (sborka=='Да'? 'Со сборкой' : 'Без сборки'), ', ', (nastprof=='Да'? 'С настенным профилем' : 'Без настенного профиля')].join('')
        }
        else{
            title =  [
                'СлайдЛюкс, ', w + 'x' + h, ', открытие ',
                tipotkr, ', ', tip, ' рельсовая, ', kolvoStvorok, ' створки(ок) ', ((pokraska =='RAL'|| pokraska =='АкзоНобель')? ', цвет '+ind2 + ' '+ ind10 : pokraska =='Анодирование'? ', Анодирование '+ tipAnod :  'Без покраски' ), ', стекло ', ind4, ', ', ind6,
                stoporTitle, ', ', ind8, zaschelkaTitle, ', ', mestekUpl, ', ', (sborka=='Да'? 'Со сборкой' : 'Без сборки'), ', ', (nastprof=='Да'? 'С настенным профилем' : 'Без настенного профиля')].join('')
        }

        if (ind6.toLowerCase().includes('купе')) {
            ruchka = 'купе';
        } else {
            ruchka = 'труба';
        }

        let result = {
            type: 'СлайдЛюкс',
            name: 'СлайдЛюкс',
            subname: title.replace('СлайдЛюкс, ',''),
            title: title ,
            params: {
                ind1:   tipotkr.toLowerCase()  + '-' + kolvoStvorok  + '-' + ruchka,
                ind2: 'Ral' + ind2 + ' '+ind10,
                ind3: encode(JSON.stringify({
                    width,
                    height,
                    ind2,
                    tipotkr,
                    ind4,
                    ind6,
                    ind8,
                    mestekUpl,
                    ind10,
                    kolvoStvorok,
                    tip,
                    sborka,
                    nastprof,
                    pokraska,
                    tipAnod,
                    stvwid,
                    vesstvorki,
                    cvetStopora,
                    cvetZaschelki,
                })),
                ind4: w,
                ind5: h,
                foto_small: '/img/slaydelux/' +tip + 'рел'+ kolvoStvorok +'створки' + tipotkr + '-' + ruchka + '.jpg'
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 88
        };


        stvwid = 'Ширина створки ';

        let wsh;

        if (tipotkr.includes('От-центра')) {
            wsh = Math.floor((w + (kolvoStvorok - 2) * 15 - 2 * 5 - 2 * (nastprof === 'Да' ? 10 : 5)) );
        } else {
            wsh = Math.floor(
                (w + (kolvoStvorok - 1) * 15
                    - (ind6 === 'Ручка-профиль'
                        ? (tipotkr === 'Двойное' ? 40 : 20 + (nastprof === 'Да' ? 10 : 5))
                        : 2 * (nastprof === 'Да' ? 10 : 5))
                )
            );
        }


        stvwid += Math.round(wsh / (kolvoStvorok*1)) + " мм.";


        vesstvorki = Math.round(w / (kolvoStvorok*1) * h / 1000000 * 25);

        _.forEach(data.result, function(el) {
            let item = _.cloneDeep(el);
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            //let kolvoStvorok = kolvoStvorok;
            let typeOtkr = tipotkr;



            if (name.includes('стекло') && ind4.toLowerCase() != 'Без стекла') {
                if (name.includes(ind4.toLowerCase()) ) {
                    kolvo = (w * h / 1000000).toFixed(3);
                }
            }

         /*   const tips = {
                '3': '3 рельсовая',
                '4': '4 рельсовая',
                '5': '5 рельсовая',
                '6': '6 рельсовая',
                '7': '7 рельсовая',
                '8': '8 рельсовая',
                '9': '9 рельсовая',
                '10': '10 рельсовая',
            };*/

            else if (tip == '3' && name.includes(tip) && name.includes('рельс')) {
                if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                    kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                    kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                    kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                    kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                }

            }

            else if (tip == '4' && name.includes(tip) && name.includes('рельс')) {


                let meters = w / 1000; // переводим в метры

                let quantity3 = Math.ceil(meters / 3) * 3;
                let quantity4 = Math.ceil(meters / 4) * 4;

               if   (quantity3 <= quantity4 && item.countStep == "6.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }

               }

                if   (quantity3 > quantity4 && item.countStep == "4.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }

                }

            }

            else if (tip == '5' && name.includes(tip) && name.includes('рельс')) {

                let meters = w / 1000; // переводим в метры

                let quantity3 = Math.ceil(meters / 3) * 3;
                let quantity4 = Math.ceil(meters / 4) * 4;

                if   (quantity3 <= quantity4 && item.countStep == "6.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }

                }

                if   (quantity3 > quantity4 && item.countStep == "4.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }

                }


            }



            else if (tip == '6' && name.includes('3') && name.includes('рельс')) {
                if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                    kolvo = (Math.ceil(2 * w / 1000 / 3) * 3) .toFixed(3);
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                    kolvo = (Math.ceil(2 * w / 1000 / 3) * 3) .toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                    kolvo = (Math.ceil(2 * w / 1000 / 3) * 3) .toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                    kolvo = (Math.ceil(2 * w / 1000 / 3) * 3) .toFixed(3);
                }
            }


            else if (tip == '7' && name.includes('3') && name.includes('рельс')) {
                if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                    kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                    kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                    kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                    kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                }
            }
            else if (tip == '7' && name.includes(4) && name.includes('рельс')) {


                let meters = w / 1000; // переводим в метры

                let quantity3 = Math.ceil(meters / 3) * 3;
                let quantity4 = Math.ceil(meters / 4) * 4;

                if   (quantity3 <= quantity4 && item.countStep == "6.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }

                }

                if   (quantity3 > quantity4 && item.countStep == "4.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }

                }
            }

            else if (tip == '8' && name.includes(4) && name.includes('рельс')) {


                let meters = 2*w / 1000; // переводим в метры

                let quantity3 = Math.ceil(meters / 3) * 3;
                let quantity4 = Math.ceil(meters / 4) * 4;

                if   (quantity3 <= quantity4 && item.countStep == "6.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(2*w / 1000 / 3) * 3) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 3) * 3) .toFixed(3);
                    }

                }

                if   (quantity3 > quantity4 && item.countStep == "4.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(2*w / 1000 / 4) * 4) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 4) * 4) .toFixed(3);
                    }

                }
            }



            else if (tip == '9' && name.includes(4) && name.includes('рельс')) {


                let meters = w / 1000; // переводим в метры

                let quantity3 = Math.ceil(meters / 3) * 3;
                let quantity4 = Math.ceil(meters / 4) * 4;

                if   (quantity3 <= quantity4 && item.countStep == "6.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }

                }

                if   (quantity3 > quantity4 && item.countStep == "4.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }

                }
            }

            else if (tip == '9' && name.includes(5) && name.includes('рельс')) {

                let meters = w / 1000; // переводим в метры

                let quantity3 = Math.ceil(meters / 3) * 3;
                let quantity4 = Math.ceil(meters / 4) * 4;

                if   (quantity3 <= quantity4 && item.countStep == "6.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 3) * 3) .toFixed(3);
                    }

                }

                if   (quantity3 > quantity4 && item.countStep == "4.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(w / 1000 / 4) * 4) .toFixed(3);
                    }

                }


            }

            else if (tip == '10' && name.includes(5) && name.includes('рельс')) {

                let meters = w / 1000; // переводим в метры

                let quantity3 = Math.ceil(meters / 3) * 3;
                let quantity4 = Math.ceil(meters / 4) * 4;

                if   (quantity3 <= quantity4 && item.countStep == "6.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(2*w / 1000 / 3) * 3) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 3) * 3) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 3) * 3) .toFixed(3);
                    }

                }

                if   (quantity3 > quantity4 && item.countStep == "4.0" )   {

                    if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                        kolvo = (Math.ceil(2*w / 1000 / 4) * 4) .toFixed(3);
                        pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                        pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 4) * 4) .toFixed(3);
                    }
                    if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                        kolvo = (Math.ceil(2*w / 1000 / 4) * 4) .toFixed(3);
                    }

                }


            }

            else if ((pokraska =='RAL'|| pokraska =='АкзоНобель') && name.includes('покраска') )
            {
                kolvo = 1;
               if (pokraska =='RAL'){
                    item.price = pokraskaPrice;
                    item.opt_price =pokraskaOptPrice;
                }
               else{
                   item.price = pokraskaPrice * 2;
                   item.opt_price =pokraskaOptPrice  * 2;
               }

            }
            else if (ind4.toLowerCase() != 'без стекла' && name.includes('монтаж') )
            {
                kolvo = (Math.ceil(w * h / 1000000));
            }

            else if (name.includes('панель') && ((sborka =="Да" && item.ind1=="В сборе") || (sborka =="Нет" && item.ind1=="Без сборки"))){

                if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой')) || (pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                    kolvo = (+kolvoStvorok).toFixed(3);
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                    kolvo = (+kolvoStvorok).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                    kolvo = (+kolvoStvorok).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                    kolvo = (+kolvoStvorok).toFixed(3);
                }
            }

            else if(nastprof=='Да' && name.includes('настенный боковой'))
            {

                if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                    kolvo = (2).toFixed(3);
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                    kolvo = (2).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                    kolvo = (2).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                    kolvo = (2).toFixed(3);
                }
            }

           /*

            else if(nastprof=='Да' && name.includes('Фетр 9мм'.toLowerCase())){
                kolvo = (((+tip - 1) * h + 4 * h) / 1000).toFixed(3);
            }

            else if(nastprof=='Нет' && name.includes('Фетр 9мм'.toLowerCase())){
                kolvo = ((+kolvoStvorok-1) * h / 1000).toFixed(3);
            }
            */


            else if(name.includes('Фетр 9мм'.toLowerCase()) ){

                if (!mestekUpl.includes('Межстекольный зацеп') &&  !mestekUpl.includes('ПВХ')){
                    if (tipotkr.includes('От-центра')){
                        kolvo = (+kolvoStvorok-2) * h / 1000;
                    }
                    else{
                        kolvo = (+kolvoStvorok-1) * h / 1000;
                    }
                }


                if(nastprof=='Да' && ind6!='Ручка-профиль' ) {
                    kolvo= +kolvo +  4 * h / 1000
                }


            }


            else if(name.includes('Фетр верхний 6мм'.toLowerCase())){
                kolvo = ((+tip)*2 * w / 1000).toFixed(3);

                if(nastprof=='Да' && ind6=='Ручка-профиль' ) {

                    if (tipotkr.includes('От-центра') || tipotkr.includes('Двойное')){
                        kolvo= +kolvo +  2 * h / 1000 + 4 * h / 1000
                    }
                    else{
                        kolvo= +kolvo +  1 * h / 1000  + 4 * h / 1000
                    }

                }

            }

            else if(name.includes('Демпфер'.toLowerCase())){


                if (tipotkr.includes('От-центра')){
                    kolvo = (+kolvoStvorok-2).toFixed(3);
                }
                else{
                    kolvo = (+kolvoStvorok-1).toFixed(3);
                }

            }
            else if(name.includes('Стопор верхний'.toLowerCase())){
                if ( tipotkr.toLowerCase().includes('от-центра')) { //
                    kolvo = (2).toFixed(3);
                }
                else if (tipotkr.toLowerCase() == 'двойное' ) { //
                   //
                }
                else {
                        kolvo = (1).toFixed(3);
                    }
                }

            else if(name.includes('Стопор нижний'.toLowerCase())){
                if ( tipotkr.toLowerCase().includes('от-центра')) { //
                    kolvo = (2).toFixed(3);
                }
            }


            else if(tipotkr.includes('центр') && name.includes('Торцевой алюминиевый профиль'.toLowerCase())){
                if ((pokraska == 'RAL' && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                    kolvo = (2).toFixed(3);
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                    kolvo = (2).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                    kolvo = (2).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                    kolvo = (2).toFixed(3);
                }
            }


            else if(nastprof=='Нет' && name.includes('Торцевой ПВХ профиль'.toLowerCase()))
            {

                if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                    kolvo = (2).toFixed(3);
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                    kolvo = (2).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                    kolvo = (2).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                    kolvo = (2).toFixed(3);
                }
            }


            else if(name.includes('Створочный профиль'.toLowerCase()))
            {

                if (((pokraska =='RAL'|| pokraska =='АкзоНобель') && item.ind2.toLowerCase().includes('сырой'))||(pokraska == 'Без покраски' && item.ind2.toLowerCase().includes('сырой'))) {
                    kolvo = (w/1000 * 1.03).toFixed(3);
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')   ) {
                    kolvo = (w/1000* 1.05).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Бронза' && item.ind2.toLowerCase().includes('коричневый')   ) {
                    kolvo = (w/1000* 1.05).toFixed(3);
                }
                if (pokraska == 'Анодирование' && tipAnod == 'Черный' && item.ind2.toLowerCase().includes('черный')   ) {
                    kolvo = (w/1000* 1.05).toFixed(3);
                }
            }


            else if(nastprof=='Нет' && name.includes('Фетр 12 мм'.toLowerCase())){
                kolvo = (2 * h/1000).toFixed(3);
            }

            else if( ind8 == 'Замок-защелка нижний' && name.includes('защелка нижний') && matchesFurnColor(item, cvetZaschelki)){

                if (pokraska =='RAL'|| pokraska =='АкзоНобель') {

                    if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                        kolvo = (2).toFixed(3);
                    }
                    else {
                        kolvo = (1).toFixed(3);
                    }

                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                else {
                    if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                        kolvo = (2).toFixed(3);
                    }
                    else {
                        kolvo = (1).toFixed(3);
                    }
                }

            }

            else if( ind8 == 'Замок-защелка боковой' && name.includes('защелка боковой')){

                if (pokraska =='RAL'|| pokraska =='АкзоНобель') {

                    if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                        kolvo = (2).toFixed(3);
                    }
                    else {
                        kolvo = (1).toFixed(3);
                    }


                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }
                else{
                    if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                        kolvo = (2).toFixed(3);
                    }
                    else {
                        kolvo = (1).toFixed(3);
                    }
                }
            }

            else if( ind8 == 'Замок стена-стекло' && name.includes('замок стена-стекло')){

                if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                    kolvo = (2).toFixed(3);
                }
                else {
                    kolvo = (1).toFixed(3);
                }
            }
            else if( (ind8 == 'Замок стекло-стекло' || ind8 =='Замок на стекло (от центра)') && name.includes('замок стекло-стекло')){

                if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                    kolvo = (1).toFixed(3);
                }
                else {
                    kolvo = (1).toFixed(3);
                }
            }


            else if( ind6.includes('Ручка-профиль') && name.includes(ind6.toLowerCase()) ){

                if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                    kolvo = (2).toFixed(3);

                    item.price=item.price/2;
                    item.opt_price= item.opt_price/2;

                }
                else {
                    kolvo = (1).toFixed(3);
                    item.flag = false;
                }

                if (pokraska =='RAL'|| pokraska =='АкзоНобель') {
                    pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                    pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                }

            }

            else if( !ind6.includes('Ручка-профиль') && name.includes(ind6.toLowerCase()) ){

                if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                    kolvo = (2).toFixed(3);
                }
                else {
                    kolvo = (1).toFixed(3);
                }

            }

            else if( ind6 !== 'Ручка своя' && !ind6.includes('купе') && name.includes('Стопор для ручки'.toLowerCase()) && matchesFurnColor(item, cvetStopora) ){

                if (tipotkr.toLowerCase() == 'двойное' || tipotkr.toLowerCase().includes('от-центра')) { // замок
                    kolvo = (2).toFixed(3);
                }
                else {
                    kolvo = (1).toFixed(3);
                }



            }

            else if( (mestekUpl.includes('ПВХ') && name.includes('Межстекольный ПВХ профиль'.toLowerCase()))
                ||(mestekUpl.includes('Алюминиевый') && name.includes('Межстекольный алюминиевый профиль'.toLowerCase()))
                ||(mestekUpl.includes('Межстекольный зацеп') && name.includes('Межстекольный зацеп'.toLowerCase()))
            ){


                if ((mestekUpl.includes('Алюминиевый')|| mestekUpl.includes('Межстекольный зацеп')) && pokraska == 'Анодирование' && tipAnod == 'Серебро' && item.ind2.toLowerCase().includes('серебро')
                 || (mestekUpl.includes('Алюминиевый') || mestekUpl.includes('Межстекольный зацеп')) && pokraska != 'Анодирование'  && item.ind2.toLowerCase().includes('сырой')
                ) {
                    if ( tipotkr.toLowerCase().includes('от-центра')) {
                        kolvo = (+kolvoStvorok-2).toFixed(3);
                    }
                    else{
                        kolvo = (+kolvoStvorok-1).toFixed(3);
                    }
                }

                if (!mestekUpl.includes('Алюминиевый') && !mestekUpl.includes('Межстекольный зацеп')) {
                    if ( tipotkr.toLowerCase().includes('от-центра')) {
                        kolvo = (+kolvoStvorok-2).toFixed(3);
                    }
                    else{
                        kolvo = (+kolvoStvorok-1).toFixed(3);
                    }
                }

                 if (name.includes('Межстекольный зацеп'.toLowerCase())){

                     kolvo = kolvo * 2;
                 }

                 if (mestekUpl.includes('Межстекольный зацеп') && name.includes('Межстекольный зацеп'.toLowerCase()) && (pokraska =='RAL'|| pokraska =='АкзоНобель') && kolvo) {
                     pokraskaPrice = pokraskaPrice + kolvo * item.price/10;
                     pokraskaOptPrice = pokraskaOptPrice + kolvo * item.opt_price/10;
                 }

             /*   const mezstekolka = {
                    'ПВХ уплотнитель с фетром': 'ПВХ уплотнитель с фетром',
                    'Алюминиевый уплотнитель с фетром':'Алюминиевый уплотнитель с фетром',
                };
                Межстекольный алюминиевый профиль, 3м Коричневый(анодированный)
                Межстекольный ПВХ профиль 3 м Коричневый(анодированный)

                */
            }



            else if(name.includes('Ролик пара'.toLowerCase())){
                kolvo = (+kolvoStvorok).toFixed(3);

            }


            else if(name.includes('Зацеп с зубом'.toLowerCase())){



                if (tipotkr.includes('От-центра')){
                    kolvo = (+kolvoStvorok-2).toFixed(3);
                }
                else{
                    kolvo = (+kolvoStvorok-1).toFixed(3);
                }

            }

            else if(name.includes('Зацеп без зуб'.toLowerCase())){


                if (tipotkr.includes('От-центра')){
                    kolvo = (+kolvoStvorok*2 -(+kolvoStvorok-2)).toFixed(3);
                }
                else{
                    kolvo = (+kolvoStvorok*2 -(+kolvoStvorok-1)).toFixed(3);
                }


            }


            else if(name.includes('Саморез для зацепов'.toLowerCase())){
                kolvo = (+kolvoStvorok*4).toFixed(3);
            }

            else if(name.includes('Саморез для роликов'.toLowerCase())){
                kolvo = (+kolvoStvorok*2).toFixed(3);
            }

            else {



            }


            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * (item.flag ? 1 : 0 ) *  item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * (item.flag ? 1 : 0 ) *  item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        if ((pokraska =='RAL'|| pokraska =='АкзоНобель')) {
            const paintName = _.findKey(result.materials, (mat, matName) => String(matName).toLowerCase().includes('покраска'));
            if (paintName) {
                const mat = result.materials[paintName];
                const unitRozn = pokraska == 'RAL' ? pokraskaPrice : pokraskaPrice * 2;
                const unitOpt = pokraska == 'RAL' ? pokraskaOptPrice : pokraskaOptPrice * 2;
                mat.oprice.rozn = (+unitRozn).toFixed(2);
                mat.oprice.opt = (+unitOpt).toFixed(2);
                const paintKolvo = +mat.count;
                const spis = 1 + mat.spis / 100;
                mat.price.rozn = fixprecision(paintKolvo * spis * unitRozn);
                mat.price.opt = fixprecision(paintKolvo * spis * unitOpt);
            }
        }

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    change();
</script>

    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-12 col-sm-5">

                <div class="text-center">
                    <!--4рел8створкиОт-центра-труба-->
                    <img style="max-height: 250px" class="img-fluid px-3" src="/img/slaydelux/{tip}рел{kolvoStvorok}створки{tipotkr}-{ruchka}.jpg" />
                </div>

                {#if tipotkr && $width*$height>0 }
                   <!-- {@const item = opening.find((el) => el.key === tipotkr)}-->

                    <div class="row pt-3">


                        <div class="col-12 text-center">
                            <span class="form-label text-center">
                                { stvwid.split(' мм.').join(" мм. ") }
                            </span>
                        </div>
                        <div class="col-12 text-center pt-3">
                            <span class="form-label text-center { vesstvorki> 80 ? 'text-danger' : '' }">
                                { 'Вес створки ' + vesstvorki + " кг." }
                            </span>

                            <span class="form-label pt-2 text-center { vesstvorki> 80 ? 'text-danger' : 'd-none' }">
                                Гарантия при весе<br>створки до 80 кг.
                            </span>
                        </div>
                        <div class="col-12 text-center pt-3">
                            <span class="form-label text-center">Площадь остекления: {($width / 1000 *  $height / 1000 ).toFixed(2) } м.кв.</span>

                        </div>
                    </div>
                {/if}

                <div class="text-center">

                    {#if ind6!= 'Ручка своя'}
                        <img style="max-height: 100px; min-width: 100px" class="img-fluid px-3" src="/img/slaydors/{handleImages[ind6]}" />

                    {/if}



                </div>
            </div>
            <div class="col-12 col-sm-7">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 10000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 3000) || vesstvorki> 80) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">
                    <div class="col-6 d-none">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Количество изделий</label>
                                <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Сборка нужна</label>
                                <select class="form-control form-select" bind:value={sborka} on:change={changeSborka}>
                                    <option value="Да">Да</option>
                                    <option value="Нет">Нет</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Ширина конструкции, мм</label>

                                <input type="number"
                                       class="form-control text-center { $width > 50000 ? 'text-danger' : '' }"
                                       step="1"
                                       min="550"
                                       max="50000"
                                       bind:value={$width}
                                       use:validate_not_empty={$width}
                                       use:validate_int={$width}>

                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Высота конструкции, мм</label>

                                <input type="number"
                                       class="form-control text-center { $height > 4000 ? 'text-danger' : '' }"
                                       step="1"
                                       min="200"
                                       max="5000"
                                       bind:value={$height}
                                       use:validate_not_empty={$height}
                                       use:validate_int={$height}>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип</label>
                                <select class="form-control form-select" bind:value={tip}>
                                    {#each Object.entries(tips) as [value, name]  }
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Количество створок</label>
                                <select class="form-control form-select"
                                        bind:value={kolvoStvorok}
                                        disabled={!tip || Object.keys(availableStvorokOptions).length === 0} >

                                    {#each Object.entries(availableStvorokOptions) as [value, name]}
                                        <option value={value}>{name}</option>
                                    {/each}
                                </select>

                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">

                                <label class="form-label">Тип открывания (вид изнутри)</label>

                                <select class="form-control form-select" bind:value={tipotkr}
                                        disabled={!kolvoStvorok || Object.keys(availableOpeningOptions).length === 0}>
                                    {#each Object.entries(availableOpeningOptions) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}

                                </select>
                            </div>
                        </div>
                    </div>



                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Покраска</label>
                                <select class="form-control form-select" bind:value={pokraska}>
                                    <option value="Без покраски">Без покраски</option>
                                    {#if sborka === 'Да'}
                                        <option value="RAL">RAL</option>
                                    {/if}
                                    <option value="Анодирование">Анодирование</option>
                                    <option value="АкзоНобель">АкзоНобель</option>
                                </select>

                            </div>
                        </div>
                    </div>

                    {#if (pokraska === 'RAL' || pokraska === 'АкзоНобель') && sborka === 'Да' }
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Цвет Ral</label>
                                    <!-- Текстовое поле для ввода и поиска -->
                                    <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Введите RAL..."
                                            bind:value={searchRal}
                                            on:focus={() => showRalList = true}
                                            on:blur={() => setTimeout(() => showRalList = false, 200)}
                                            autocomplete="off"
                                    />

                                    <!-- Кастомный список опций -->
                                    {#if showRalList && filteredColors.length > 0}
                                        <div class="custom-select-list" style="position: absolute; z-index: 1000; width: 100%; background: white; border: 1px solid #ccc; border-top: none; max-height: 200px; overflow-y: auto;">
                                            {#each filteredColors as [value]}
                                                <div
                                                        class="custom-option px-3 py-2 cursor-pointer hover:bg-gray-100"
                                                        on:click={() => { ind2 = value; searchRal = value; showRalList = false; }}
                                                >
                                                    {value}
                                                </div>
                                            {/each}
                                        </div>
                                    {/if}

                                    <!-- Скрытое поле для сохранения выбранного значения, если требуется -->
                                    <!-- <input type="hidden" bind:value={ind2} /> -->

                                    {#if ind2}
                                        <div class="input-group-append">
                                            <img class="input-group-text p-0" src="https://iem.plisse.ltd/resources/img/ral/{ind2.replace('RAL', '')}.jpg" alt={ind2} />
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </div>

                        <style>
                            .custom-select-list {
                                border-radius: 0.375rem; /* Соответствует стилям form-control */
                                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                                border: 1px solid #ced4da; /* Используем стандартный цвет границы */
                                border-top: none; /* Убираем верхнюю границу, чтобы она не дублировалась с input */
                            }
                            .custom-option {
                                cursor: pointer;
                                padding: 0.375rem 0.75rem; /* Соответствует внутреннему отступу option */
                            }
                            .custom-option:hover {
                                background-color: #e9ecef; /* Bootstrap hover bg */
                            }
                        </style>

                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Тип окрашивания</label>
                                    <select class="form-control form-select" bind:value={ind10} >
                                        {#each color_type as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}


                    {#if pokraska === 'Анодирование'  }
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Цвет анодирование</label>
                                    <select class="form-control form-select" bind:value={tipAnod} >
                                        <option value="Серебро">Серебро</option>
                                       <!-- <option value="Бронза">Бронза</option>
                                        <option value="Черный">Черный</option>-->
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Стекло</label>
                                <select class="form-control form-select" bind:value={ind4}>
                                    {#if sborka === 'Да'}
                                        {#each Object.entries(glass) as [value, name]}
                                            <option value="{value}">{name}</option>
                                        {/each}
                                    {/if}
                                    {#if sborka === 'Нет'}
                                        {#each Object.entries(glassDiler) as [value, name]}
                                            <option value="{value}">{name}</option>
                                        {/each}
                                    {/if}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6 d-none">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Настенный профиль</label>
                                <select class="form-control form-select" bind:value={nastprof}>
                                    <option value="Да">Да</option>
                                    <option value="Нет">Нет</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Межстекольный уплотнитель</label>
                                <select class="form-control form-select" bind:value={mestekUpl}>
                                    {#each Object.entries(mezstekolka) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>


                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип ручки </label>
                                <select class="form-control form-select" bind:value={ind6}>
                                    {#each Object.entries(handle) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    {#if ind6 !== 'Ручка своя'}
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Цвет стопора</label>
                                    <select class="form-control form-select" bind:value={cvetStopora}>
                                        {#each Object.entries(compactor) as [value, name]}
                                            <option value="{value}">{name}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Замок/защелка </label>
                                <select class="form-control form-select" bind:value={ind8}>
                                    {#each (tipotkr.includes('От-центра') ?  Object.entries(zamokOtCentr) :  Object.entries(zamok))  as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    {#if ind8 === 'Замок-защелка нижний'}
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Цвет защелки</label>
                                    <select class="form-control form-select" bind:value={cvetZaschelki}>
                                        {#each Object.entries(compactor) as [value, name]}
                                            <option value="{value}">{name}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}

                </div>

                <div class="row">

                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Примечание</label>
                                    <textarea class="form-control" bind:value={$comment}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
